import { designThinkingModule } from './modules/design-thinking';
import { creativeProblemSolvingModule } from './modules/creative-problem-solving';
import { innovationFrameworksModule } from './modules/innovation-frameworks';
import { changeManagementModule } from './modules/change-management';

export const INNOVATION_PROBLEM_SOLVING_COURSES = [
  {
    id: 'innovation-problem-solving',
    title: 'Innovation & Strategic Problem Solving',
    description: 'Apply design thinking, creative problem-solving, and innovation frameworks to drive business results.',
    level: 'advanced',
    totalDuration: '4 hours',
    image: '/api/placeholder/400/300',
    prerequisites: ['Professional work experience'],
    learningOutcomes: [
      'Apply design thinking and innovation frameworks',
      'Solve complex business and technical problems creatively',
      'Lead innovation initiatives and change management',
      'Foster innovative thinking within teams and organizations'
    ],
    modules: [
      designThinkingModule,
      creativeProblemSolvingModule,
      innovationFrameworksModule,
      changeManagementModule
    ]
  }
];